export default {
  buttons: {
    remove: 'Eliminar',
  },
  title: 'Código promocional o tarjeta de regalo',
};
